import React, { useEffect, useState } from "react";
import Background from "../../assets/images/bgim.jpeg";
import { Link } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { getRestaurant, getRestaurantLogo } from "../../state/restaurantState";
import MobresBacklink from "../../components/MobresBacklink";
import "./styles.css";

// Firma adı/logosu gösterilmeyecek firmalar.
const WHITELIST_IDS = ["MP365"];

// Resim yoksa API data URI yerine XML hata metni döner; onu resim sayma.
const isImageData = (value) => typeof value === "string" && value.startsWith("data:image");

// INSTAGRAM alanı bazen tam link, bazen sadece kullanıcı adı olarak gelir.
const instagramUrl = (value) => {
  const v = (value || "").trim();
  if (!v) return null;
  return /^https?:\/\//i.test(v) ? v : `https://instagram.com/${v.replace(/^@/, "")}`;
};

const FirstPage = ({ id }) => {
  const dispatch = useDispatch();
  const { restaurant, logo } = useSelector((state) => state.restaurants);
  const [background, setBackground] = useState(null);

  // URL'den id parametresini al veya prop'tan kullan
  const urlId = new URLSearchParams(window.location.search).get("id");
  const userCode = id || urlId;
  const isWhitelistId = userCode && WHITELIST_IDS.includes(userCode);

  useEffect(() => {
    if (!userCode) return;
    dispatch(getRestaurant(userCode));
    dispatch(getRestaurantLogo(userCode));

    let active = true;
    fetch(
      `https://1zw31qczi7.execute-api.eu-central-1.amazonaws.com/prod/restaurant_pictures/${userCode}/1`
    )
      .then((res) => res.text())
      .then((text) => {
        if (active && isImageData(text?.trim())) setBackground(text.trim());
      })
      .catch(() => null);
    return () => {
      active = false;
    };
  }, [dispatch, userCode]);

  const restaurantData = Array.isArray(restaurant) && restaurant.length > 0 ? restaurant[0] : null;
  const showBrand = !isWhitelistId;
  const logoSrc = showBrand && isImageData(logo) ? logo : null;
  const instagram = instagramUrl(restaurantData?.INSTAGRAM);
  const whatsapp = restaurantData?.WHATSAPP?.trim();
  const address = restaurantData?.ADRES?.trim();

  return (
    <div className="fp">
      <img src={background || Background} alt="" className="fp-bg" />
      <div className="fp-scrim" />

      <main className="fp-content">
        {logoSrc && <img src={logoSrc} alt="Firma logosu" className="fp-logo" />}

        {showBrand && restaurantData?.FIRMA && (
          <>
            <span className="fp-welcome">Hoş geldiniz</span>
            <h1 className="fp-name">{restaurantData.FIRMA}</h1>
          </>
        )}

        <Link to="/category" className="fp-cta">
          Menüyü Görüntüle
          <svg viewBox="0 0 24 24" width="20" height="20" fill="none" stroke="currentColor" strokeWidth="2.2" strokeLinecap="round" strokeLinejoin="round">
            <path d="M5 12h14M13 6l6 6-6 6" />
          </svg>
        </Link>

        {showBrand && (instagram || whatsapp) && (
          <div className="fp-social">
            {instagram && (
              <a href={instagram} target="_blank" rel="noopener noreferrer" aria-label="Instagram">
                <i className="fab fa-instagram" />
              </a>
            )}
            {whatsapp && (
              <a href={whatsapp} target="_blank" rel="noopener noreferrer" aria-label="WhatsApp">
                <i className="fab fa-whatsapp" />
              </a>
            )}
          </div>
        )}
      </main>

      <footer className="fp-bottom">
        {showBrand && address && (
          <p className="fp-address">
            <i className="fas fa-map-marker-alt" /> {address}
          </p>
        )}
        <MobresBacklink variant="light" />
      </footer>
    </div>
  );
};

export default FirstPage;
